__turbopack_context__.v({
  "className": "t4OGka_className",
  "variable": "t4OGka_variable",
});
